import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom';
import * as actionCreator from '../../redux/actions/data-action';
import { TerminationType } from '../../redux/actions/data-action';

class TerminationDemographics extends Component {
    componentWillMount() {
        const { setTermination } = this.props;
    
        setTermination(TerminationType.DEMOGRAPHICS);
    }

    render() {
        return (
            <Redirect to={{ pathname: "/Demographic/Terminate" }} />
        )
    }
}

export default connect(null, actionCreator)(TerminationDemographics);